import * as React from 'react';

import meta from './meta';
import { buildNewLeaderboardRow, processNewLeaderboardApi } from './processing';

// Config
import { SHARED_REFRESH_RATE } from '../../config';

// Components
import ApiTable from '../../components/ApiTable/ApiTable';
import BassComponent from '../../components/BassComponent/BassComponent';

// Higher-order components
import withTournamentTypeFromParams from '../../hoc/withTournamentTypeFromParams';

// Types
import {
  cutlineContext,
  ICutline,
  IWithTournamentType,
  TournamentClass,
  TournamentId,
  TournamentType,
} from '../../types';

import { ILeaderboardAnglerRedis } from './types';

interface IProps extends IWithTournamentType {
  tid: TournamentId;
  limit?: number;
  // NOTE: gets `type` from extends, either 1 (pro) | 0 (co).
  // type: TournamentType;
  space: TournamentClass;
  // Cutline
  cutlines?: ICutline[];
}

export class Leaderboard extends React.Component<IProps> {
  public static defaultProps: Pick<IProps, 'space' | 'cutlines'> = {
    cutlines: [],
    space: TournamentClass.ELITE,
  };

  private apiBase = '/data/leaderboard';

  public buildLeaderboardRowWithSpace = (entry: ILeaderboardAnglerRedis) =>
      buildNewLeaderboardRow(entry);

  public render() {
    return (
      <div className="leaderboard" data-testid="leaderboard">
        <BassComponent
          meta={{
            ...meta,
            ...{
              nickname: `Leaderboard${
                this.props.type === TournamentType.PRO ? `: Pro` : 'Co'
              }`,
            },
          }}
        >
          <h3 className="leaderboard-table__title">Tournament Standings</h3>
          <cutlineContext.Provider
            value={{
              cutlines: this.props.cutlines ? this.props.cutlines : [],
            }}
          >
            <ApiTable
              apiUri={this.apiUri()}
              apiProcessor={processNewLeaderboardApi}
              limit={this.props.limit}
              tableRowFormatter={this.buildLeaderboardRowWithSpace}
              refreshRate={SHARED_REFRESH_RATE}
              messageNoResults="Tournament has not started."
            />
          </cutlineContext.Provider>
        </BassComponent>
      </div>
    );
  }

  private apiUri = () => {
    const { tid, type } = this.props;
    const tType = type === TournamentType.PRO ? 'anglers' : 'coanglers';
    return `/wp-json/data/v1/tournament/leaderboard?tournament_id=${tid}&class=${tType}`;
  };
}

export default withTournamentTypeFromParams(Leaderboard);
